/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MiddleName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function MiddleName({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Person/MiddleName",
  isInvalid,
  onChange
  
}) {
let editProfessionalOtherPersonMiddleNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'other.person.middle_name',
})
let editProfessionalOtherPersonMiddleNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'other.person.middle_name',
validate: fromValidate.name,
})
let editProfessionalOtherPersonMiddleNameChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'other.person.middle_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_professional.other.person.middle_name"
 validate="/Data/validate.js name"
 invalid={!editProfessionalOtherPersonMiddleNameIsValidData}
 value={editProfessionalOtherPersonMiddleNameValueData}
 onChange={editProfessionalOtherPersonMiddleNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Middle Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}